export const SUPPORT_EMAIL = 'support@EasyCheck.org';

export const INFINITE_SCROLL_BOTTOM_OFFSET_PX = 300;
export const INFINITE_SCROLL_DEBOUNCE_TIME_MS = 3000;
export const TOOLTIP_APPEAR_DELAY = 1000;

export const REFRESH_TOKEN_IN_MINUTES = 10;
export const DEFAULT_PAGE_SIZE = 20;
export const USER_INPUT_DEBOUNCE_TIME_MS = 500;

export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY';
export const DISPLAY_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';

export enum PersisTables {
  Members = 'members',
  Banks = 'banks',
  Payments = 'payments',
  Payees = 'payees',
  Audits = 'audits',
}

export const TAWK_PROPERTY_ID = process.env['TAWK_PROPERTY_ID'];
export const TAWK_WIDGET_ID = process.env['TAWK_WIDGET_ID'];
